module.exports = __webpack_public_path__ + "static/media/Vullaby_gaussian2.3bdf6080.png";